import http from 'services/httpService';

const getNotifications = async (userId) => {
  try {
    const response = await http.get(`/api/notification/all/${userId}`);
    return response.data?.data || [];
  } catch (error) {
    throw error;
  }
};

const getUnseenNotifications = async (userId) => {
  try {
    const response = await http.get(`/api/notification/all/notSeen/${userId}`);
    // console.log("Unseen", response);
    return response.data?.data || [];
  } catch (error) {
    throw error;
  }
};

const markNotificationAsSeen = async (userId, notificationId) => {
  try {
    await http.patch(`/api/notification/seen/${userId}/${notificationId}`);
  } catch (error) {
    throw error;
  }
};

const markNotificationsAsSeen = async (userId, notificationId) => {
  try {
    await http.patch(`/api/notification/seen/${userId}`);
  } catch (error) {
    throw error;
  }
};



export default { getNotifications, getUnseenNotifications, markNotificationsAsSeen, markNotificationAsSeen };